import React from 'react';
import ReactDOM from 'react-dom';
import { AppProvider } from './Stores/App.store';
import App from './Components/App/App';
import "./Static/css/reset.scss";
ReactDOM.render(
  <React.StrictMode>
    <AppProvider>
      <App/>
    </AppProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
